import { Pipe, PipeTransform } from '@angular/core';
import linkifyStr from 'linkifyjs/string';

import * as moment from 'moment';

@Pipe({name: 'formatDate'})
export class FormatDatePipe implements PipeTransform {
  transform(date: string) : string {
    let formatDate = moment(date);
    moment.locale('es')
    return formatDate.format('DD MMM YYYY');
  }
}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/pipes/date.component.ts